module.exports = __webpack_public_path__ + "img/ARM.04acdf92.svg";